/**
 * PrivacyENPrivacyPageView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait PrivacyENPrivacyPage
 */

import { usePrivacyENPrivacyPageLogic } from '@/hooks/traits/usePrivacyENPrivacyPageLogic';
import type { PrivacyENPrivacyPageConfig } from '@/hooks/traits/usePrivacyENPrivacyPageLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { PrivacyENPrivacyView as PrivacyENPrivacyViewEntity } from '@app/shared';
import { Stack } from '@almadar/ui/components';
import { PrivacyENPrivacyTextView } from '@/components/traits/PrivacyENPrivacyTextView';
import { Box } from '@almadar/ui/components';
import { PrivacyENPrivacyHeaderView } from '@/components/traits/PrivacyENPrivacyHeaderView';
import { PrivacyENPrivacyFooterView } from '@/components/traits/PrivacyENPrivacyFooterView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface PrivacyENPrivacyPageViewProps {
  config?: Partial<PrivacyENPrivacyPageConfig>;
}

export function PrivacyENPrivacyPageView({ config: propsConfig }: PrivacyENPrivacyPageViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = usePrivacyENPrivacyPageLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['PrivacyENPrivacyView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="PrivacyEN" trait="PrivacyENPrivacyPage">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="PrivacyENPrivacyPage">{slotWriter['main'] === 'INIT' ? (<Stack gap="none" direction="vertical"><PrivacyENPrivacyHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><Box className="py-16 md:py-24" fullWidth={true} bg="transparent"><PrivacyENPrivacyTextView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Box><PrivacyENPrivacyFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default PrivacyENPrivacyPageView;
